// src/components/common/profile/SignatureSection.jsx
import React from "react";
import SignatureForm from "../../forms/SignatureForm";

export default function SignatureSection({
  isMyProfile,
  signaturePreview,
  setSignatureFile,
  setSignaturePreview,
}) {
  return (
    <div className="px-5 py-4">
      <h3 className="font-medium mb-2">서명</h3>

      {isMyProfile ? (
        <SignatureForm
          value={signaturePreview}
          onChange={(previewUrl, fileOrBlob) => {
            setSignaturePreview(previewUrl || null);
            setSignatureFile(fileOrBlob || null);
          }}
        />
      ) : (
        <div className="border rounded-md p-4 flex justify-center bg-gray-50">
          {signaturePreview ? (
            <img
              src={signaturePreview}
              alt="User Signature"
              className="h-24 object-contain"
            />
          ) : (
            <span className="text-gray-400 text-sm">
              등록된 서명이 없습니다.
            </span>
          )}
        </div>
      )}
    </div>
  );
}
